import React from "react";
import { VariantBase } from "~/components/newsletter/newsletter-widget/variants/component";
import { Container, theme } from "./styles";
export { config as newsletterArticleBottomThemeConfig } from "./config";
export const NewsletterArticleBottomTheme = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(VariantBase, {
  theme: theme,
  "data-qa": "newsletter-article-bottom-theme"
}, /*#__PURE__*/React.createElement(Container, props, children));
NewsletterArticleBottomTheme.displayName = "NewsletterArticleBottomTheme";